import { invoiceStatusId } from "~/modules/billing/api/invoiceStatus/invoiceStatusId.ts";
import type { InvoiceStatus } from "~/modules/billing/api/invoiceStatus/invoiceStatusIdTypes.ts";
import type { InvoiceStatusId } from "~/modules/billing/api/processedInvoice/processedInvoiceTypes.ts";
import type {
	InvoiceProgressSegmentState,
} from "~/modules/billing/components/InvoiceDetailsView/components/InvoiceStatusProgressBar/invoiceStatusProgressBarTypes.ts";
import { processedStatuses } from "~/modules/billing/utils/billingUtils.ts";

type SegmentThemeParams = {
	currentInvoiceStatusId: InvoiceStatusId;
	currentStatusOrderPosition: number;
	isSelfBilledInvoice: boolean;
	recipientIsSet: boolean;
	status: InvoiceStatus;
};

export function getSegmentTheme({
	currentInvoiceStatusId,
	currentStatusOrderPosition,
	isSelfBilledInvoice,
	status,
	recipientIsSet,
}: SegmentThemeParams): InvoiceProgressSegmentState {
	const unavailableStatusesForSelfBilledInvoice: InvoiceStatusId[] = [invoiceStatusId.Draft, invoiceStatusId.AwaitingApproval, invoiceStatusId.Approved];

	if (status.id === invoiceStatusId.Reversed) return "reversed";
	if (status.id === invoiceStatusId.Paid && status.order === currentStatusOrderPosition) return "paid";
	if (status.order === currentStatusOrderPosition) return "active";

	if (isSelfBilledInvoice && unavailableStatusesForSelfBilledInvoice.includes(status.id)) {
		return "status-unavailable";
	}

	if (status.order < currentStatusOrderPosition) return "completed";

	if (processedStatuses.includes(status.id) && !recipientIsSet) {
		return "disabled";
	}

	if (status.id === invoiceStatusId.Paid && currentInvoiceStatusId !== invoiceStatusId.SentToClient) {
		return "disabled";
	}

	return "upcoming";
}

type GetTooltipTextForSegmentParams = {
	currentStatusId: InvoiceStatusId;
	isSelfBilledInvoice: boolean;
	statusId: InvoiceStatusId;
	theme: InvoiceProgressSegmentState;
};

export function getTooltipTextForSegment({
	currentStatusId,
	isSelfBilledInvoice,
	statusId,
	theme,
}: GetTooltipTextForSegmentParams) {
	if (isSelfBilledInvoice && theme === "status-unavailable") {
		return "Dieser Status ist für Gutschriften nicht verfügbar";
	}

	if (statusId === invoiceStatusId.Paid && !processedStatuses.includes(currentStatusId) && theme === "disabled") {
		return "Dieser Status kann erst ausgewählt werden, wenn die Rechnung an den Kunden gesendet wurde";
	}

	if (statusId === invoiceStatusId.SentToClient && theme === "disabled") {
		return "Dieser Status kann erst ausgewählt werden, wenn der Rechnungsempfänger eingetragen wurde.";
	}
	return "";
}